import React,{useEffect, useState} from 'react';
import 'moment/locale/es';

import MasterLayout from '../layouts/MasterLayout';
import RouteSwitch from '../routes/RouteSwitch';
import menuConfig from '../menus/menuConfig';
import Routes from '../routes'; 
 
import 'moment/locale/en-gb';
import { useSelector } from 'react-redux';
import { RootState } from '@app/redux/reducers/state';


const RootPage = (props: any) => {
  const [isCompact, setIsCompact] = useState(false);

  const onChangeLanguage = (key: any) => {
    // localStorage.setItem("locale", key.key);
    // SetLocale(key.key === "en" ? enUS : es_ES);
    // i18n.changeLanguage(key.key);
  };

  return (
        <MasterLayout onChangeLanguage={onChangeLanguage} {...props} routes={Routes} menus={menuConfig}>
          <RouteSwitch {...props}  routes={props.routes} />
        </MasterLayout>
  );
};

export default RootPage;
